import http from '@/utils/http'

export function getQuestionFeedbackCategories(params){
    return http.get('/question_feedback_categories',{params})
}
export function addQuestionFeedbackCategories(data){
    return http.post('/question_feedback_categories',data)
}
export function getQuestionFeedbackCategoriesDetail(id){
    return http.get(`/question_feedback_categories/${id}`)
}
export function putQuestionFeedbackCategories(id,data){
    return http.put(`/question_feedback_categories/${id}`,data)
}
export function deleteQuestionFeedbackCategories(id){
    return http.delete(`/question_feedback_categories/${id}`)
}
export function getDeepseekChat(params){
    return http.get('/chat',{params})
}
export function bigmodelChat(params){
    return http.get('/bigmodelChat',{params})
}
export function getQuestions(params){
    return http.get('/questions',{params})
}
export function getQuestions2(params){
    return http.get('/questionsList',{params})
}
export function addQuestion(data){
    return http.post('/questions',data)
}
export function getQuestionDetail(id){
    return http.get(`/questions/${id}`)
}
export function putQuestion(id,data){
    return http.put(`/questions/${id}`,data)
}
export function putCopyQuestion(id,data){
    return http.put(`/questions/${id}/copy`,data)
}
export function putBatchCopyQuestion(data){
    return http.put(`/questionsBatchCopy/batchCopy`,data)
}
export function deleteQuestion(id){
    return http.delete(`/questions/${id}`)
}


export function getQuestionFeedbacksDetail(id){
    return http.get(`/question_feedbacks/${id}`)
}
export function getQuestionFeedbacks(params){
    return http.get('/question_feedbacks',{params})
}












export function getQuestionUnits(id){
    return http.get(`/questions/${id}/units`)
}